export default __webpack_public_path__ + "static/media/delete.b2047de9.svg";